export default "__VITE_ASSET__DZYsL_Lo__"